module.exports = __webpack_public_path__ + "img/2a) Hotel Weitzer - Graz.jpg";